import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DoubleArrow, Check } from '@mui/icons-material';
import { popOver, laserPipe } from '../../assets/templates';
import ProductsData from '../../api/products';
import Consumptions from '../../api/consumptions';
import Select from '../ui/Select';

const SelectMachineView = ({
  view,
  setView,
  calculationsData,
  setCalculationsData,
  machines,
  setMachines,
}) => {
  const getApiData = async () => {
    if (machines?.length > 0) return;
    // trae todas las maquinas
    const response = await ProductsData.getProducts()
      .then((res) => res)
      .catch((err) => err);

    setMachines(response);
  };

  const handleMachineConsumptions = async (id) => {
    // trae los datos de consumo de electricidad de la maquina seleccionada
    const response = await Consumptions.getConsumptionsByProduct(id)
      .then((res) => res)
      .catch((err) => err);

    setCalculationsData({
      ...calculationsData,
      machine: {
        ...machines.filter((machine) => machine.id === id)[0],
        pipe: laserPipe.filter((pipe) => pipe.id === id)[0]?.pipes[0],
      },
      machineConsumptions: response,
      pipes: laserPipe.filter((pipe) => pipe.id === id)[0]?.pipes,
    });
  };

  useEffect(() => {
    getApiData();
  }, []);

  return (
    <div className="main-container" style={{ position: 'relative' }}>

      {calculationsData?.machine?.id
      && (
        <button
          onClick={() => setView(view + 1)}
          id="button"
          className="simple-button"
          data-available={calculationsData?.machine?.id && true}
          type="button"
          style={{ position: 'absolute', top: '0', right: '0' }}
        >
          <DoubleArrow />
          Siguiente paso
        </button>
      )}

      <div className="item-container icon-wrapper">
        <p className="mr-t-0">
          {(calculationsData?.machine.name)
            && (<Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
          Seleccione la maquina que desea utilizar
        </p>
        <div data-title={popOver[44]}>
          <img
            alt="icon"
            src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
          />
        </div>
        <Select
          setValue={(value) => {
            const mockMachines = [...machines];
            const [machine] = mockMachines.filter((item) => item.name === value);
            handleMachineConsumptions(machine.id);
          }}
          value={calculationsData?.machine?.name}
          options={machines}
          property="name"
          placeholder="Seleccionar opcion"
        />
        {(calculationsData?.machine.name)
        && (
        <>
          <p>
            Tubo Laser CO2
          </p>
          <div data-title={popOver[48]}>
            <img
              alt="icon"
              src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
            />
          </div>
          <Select
            setValue={(value) => {
              setCalculationsData({
                ...calculationsData,
                machine: {
                  ...calculationsData.machine,
                  pipe: calculationsData?.pipes.filter((pipe) => pipe.pipeName === value)[0],
                },
              });
            }}
            value={calculationsData?.machine?.pipe?.pipeName || ''}
            options={calculationsData?.pipes}
            property="pipeName"
            placeholder="Seleccionar opcion"
          />
        </>
        )}
      </div>

      {calculationsData?.machine?.url
        && (
        <model-viewer
          id="img-machine"
          src={calculationsData.machine?.url}
          alt="A 3D model of an astronaut"
          ar
          ar-modes="webxr scene-viewer quick-look"
          environment-image="neutral"
          auto-rotate
          camera-controls
          style={{
            maxWidth: '80%', width: 'auto', height: '400px', margin: '0 auto',
          }}
        />
        )}
    </div>
  );
};

SelectMachineView.propTypes = {
  view: PropTypes.number.isRequired,
  setView: PropTypes.func.isRequired,
  calculationsData: PropTypes.shape({
    pipes: PropTypes.arrayOf(PropTypes.shape({
      pipeName: PropTypes.string,
      durability: PropTypes.number,
      price: PropTypes.number,
      costPerHour: PropTypes.number,
    })),
    machine: PropTypes.shape({
      pipe: PropTypes.shape({
        pipeName: PropTypes.string,
        durability: PropTypes.number,
        price: PropTypes.number,
        costPerHour: PropTypes.number,
      }),
      id: PropTypes.string,
      lengthCut: PropTypes.number,
      name: PropTypes.string,
      productModel: PropTypes.string,
      shopifyPrice: PropTypes.number,
      url: PropTypes.string,
      witdhCut: PropTypes.number,
    }),
  }).isRequired,
  machines: PropTypes.arrayOf(PropTypes.shape({
    corte_ancho: PropTypes.number,
    corte_largo: PropTypes.number,
    id_producto: PropTypes.string,
    imgurls: PropTypes.string,
    modelo_interno: PropTypes.string,
    nombre_producto: PropTypes.string,
    precio_shopify: PropTypes.number,
  })).isRequired,
  setMachines: PropTypes.func.isRequired,
  setCalculationsData: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => (
  {
    view: state.view,
    calculationsData: state.calculationsData,
    machines: state.machines,
  });

const mapDispatchToProps = (dispatch) => ({
  setView: (values) => dispatch({
    type: 'SET_VIEW',
    payload: values,
  }),
  setCalculationsData: (values) => dispatch({
    type: 'SET_CALCULATIONS_DATA',
    payload: values,
  }),
  setMachines: (values) => dispatch({
    type: 'SET_MACHINES',
    payload: values,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectMachineView);
